module.exports = __webpack_public_path__ + "img/CanadaDay2023Flyer.0e227bd0.jpg";